import { render, staticRenderFns } from "./IndexMenu.vue?vue&type=template&id=31b661ae&scoped=true"
import script from "./IndexMenu.vue?vue&type=script&lang=js"
export * from "./IndexMenu.vue?vue&type=script&lang=js"
import style0 from "./IndexMenu.vue?vue&type=style&index=0&id=31b661ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b661ae",
  null
  
)

export default component.exports